import { PlaneBufferGeometry, Vector2 } from "three";
import * as THREE from "three";
import { data, atlasIndexes } from './gameData';
import { Item, Monster, Bird, Human, Cat, Tree, Cow, Frog } from './gameElements';
import gsap from 'gsap';
export class BackGround extends THREE.Object3D {
    private bgTestGeometry!: PlaneBufferGeometry;
    private bgTexture!: THREE.Texture;
    private testBG!: THREE.Mesh;

    constructor(private targetWidth: number, private targetHeight: number, urlBG: string) {
        super();

        this.bgTexture = new THREE.TextureLoader().load(urlBG, (texture) => {
            const material = new THREE.MeshBasicMaterial({ transparent: true, opacity: 0 });
            material.map = texture;
            this.bgTestGeometry = new THREE.PlaneBufferGeometry(this.targetWidth, this.targetHeight);
            //const material = new THREE.MeshBasicMaterial({ map: this.bgTexture });
            this.bgTexture.wrapS = this.bgTexture.wrapT = THREE.RepeatWrapping;
            //this.bgTexture.repeat.set(1, 1);

            this.testBG = new THREE.Mesh(this.bgTestGeometry, material);
            this.testBG.renderOrder = -2;
            this.add(this.testBG);
            gsap.to(material, 0.3, { opacity: 1 });

        });

    }
    public InitOffsetY() {
        this.bgTexture?.offset.setY(0);
    }
    public SetOffsetY(val: number): void {
        this.bgTexture?.offset.setY(this.bgTexture.offset.y + val);
    }
}

export enum MonsterStatus {
    NONE,
    INIT,
    DETECT,
    PREACTION,
    ACTION,
    HIT
}

export class TextureManger {
    private texture!: THREE.Texture;
    private material!: THREE.MeshBasicMaterial;
    constructor() {

    }
    public InitTexture(urlTexture: string) {
        this.texture = new THREE.TextureLoader().load(urlTexture);
        this.material = new THREE.MeshBasicMaterial({ map: this.texture });
        this.material.transparent = true;
    }
    public GetTexture() {
        return this.texture;
    }
    public GetMaterial() {
        return this.material;
    }
}

export enum MonsterType {
    NONE,
    COW,
    CAT,
    FROG,
    TREE,
    BIRD,
    HUMAN,
    ITEM
};
export class Board extends THREE.Object3D {
    public OnSound!: (val: string) => void;
    public OnBubbleShow!: () => void;
    public OnBlobEvent!: (type: number) => void;
    private atlasIndexes: Array<Array<number[][]>> = atlasIndexes;
    private data: string[][] = data;
    public isDemo: boolean = false;
    private bg!: BackGround;
    private currentPosY: number = this.targetHeight * 0.5;
    private guideLineMaterial = new THREE.LineBasicMaterial({ color: 0xCCCCCC });
    private guideLineGeometry = new THREE.BufferGeometry();
    public line = new THREE.Line(this.guideLineGeometry, this.guideLineMaterial);
    private textureManager: TextureManger = new TextureManger();
    private textureManagerTree: TextureManger = new TextureManger();
    private textureManagerItem: TextureManger = new TextureManger();
    private monsters = new Array<Monster>();
    private items = new Array<Monster>();
    public isDebug: boolean = false;

    constructor(private targetWidth: number, private targetHeight: number) {
        super();
        this.bg = new BackGround(this.targetWidth, this.targetHeight, '/assets/background1.jpg');

        this.textureManager.InitTexture('/assets/nobc_atlas_1_2048.png');
        this.textureManagerTree.InitTexture('/assets/nobc_atlas_2_2048.png');
        this.textureManagerItem.InitTexture('/assets/items.png');

        this.add(this.bg);
    }
    private currentIdx = -1;
    private blobCenter: THREE.Vector2 = new THREE.Vector2();
    public CheckCollider(points: THREE.Vector2[], center: THREE.Vector2) {
        this.blobCenter = center;
        for (const item of this.monsters) {
            if (item.HitTest(points)) {
                //center
                item.targetPosition = center;
            }
        }
    }
    public HitTest(points: THREE.Vector2[]) {
        for (let i = 0; i < points.length; i++) {
            for (const item of this.monsters) {
                if (!(item instanceof Human) && item.isEnabled && item.status != MonsterStatus.HIT && item.colliderSize > points[i].distanceTo(new Vector2(item.position.x, item.position.y))) {
                    item.SetStatus(MonsterStatus.HIT);
                    return true;
                }
            }
        }
        return false;
    }
    private IsIn(target: number, checkVal: Number) {
        return (checkVal >= -target * 0.5 && checkVal <= target * 0.5)
    }
    private compareObjects(obj1: number, obj2: number) {

        if (obj1 < obj2) {
            return -1
        }
        if (obj1 > obj2) {
            return 1
        }
        return 0
    }

    public RemoveAll() {
        this.bg.InitOffsetY();
        this.currentIdx = -1;
        this.currentPosY = this.targetHeight * 0.5;
        let i = this.items.length;
        while (i--) {
            const item = this.items[i];

            //todo add item effect
            
            this.remove(item!);

            item!.Dispose();
            this.items.splice(i, 1);

        }
        i = this.monsters.length;
        while (i--) {
            const item = this.monsters[i];
            this.remove(item!);
            item!.Dispose();
            this.monsters.splice(i, 1);
        }
    }

    public AddYOffset(val: number) {
        this.bg.SetOffsetY(val);

        let i = this.items.length;
        while (i--) {
            const item = this.items[i];

            item.AddYOffset(val * this.targetHeight);
            if (item.status == MonsterStatus.HIT) {
                //todo add item effect
                this.OnSound("item_1");
                switch ((item as Item).itemType) {
                    case 0: // random face
                        this.OnBlobEvent(0);
                        break;
                    case 1: // more CC
                        this.OnBlobEvent(1);
                        break;
                    case 2: // Super man
                        this.OnBlobEvent(2);
                        break;

                }
                this.remove(item!);
                item.Dispose();
                this.items.splice(i, 1);
            }
        }

        this.monsters.sort((obj1: Monster, obj2: Monster) => {
            return this.compareObjects(obj1.position.y, obj2.position.y);
        })

        i = this.monsters.length;
        let renderOrder = 0;
        while (i--) {
            const item = this.monsters[i];
            if (!(item instanceof Bird)) {
                item.SetRenderOrder(renderOrder);
                renderOrder++;
            }
            item.AddYOffset(val * this.targetHeight);
            if (!this.IsIn(this.targetWidth, item.position.x) || !this.IsIn(this.targetHeight, item.position.y)) {
                this.remove(item!);
                item!.Dispose();
                this.monsters.splice(i, 1);
            }
        }
        this.currentPosY -= val * this.targetHeight;
        const newIdx = Math.floor(this.targetHeight * 0.5 - this.currentPosY);
        if (newIdx > this.currentIdx) {
            for (let i = this.currentIdx; i < newIdx; i++) {
                this.addObject(i + 1, this.targetHeight * 0.5 - (newIdx - i - 1));
                //this.removeObject(i + 1 - this.targetHeight);
            }
        } else if (newIdx < this.currentIdx) {
            for (let i = newIdx; i < this.currentIdx; i++) {
                this.addObject(i + 1 - this.targetHeight, -this.targetHeight * 0.5 + i - newIdx);
                //this.removeObject(i + 1);
            }
        }
        this.currentIdx = newIdx;
        const points = [];
        points.push(new THREE.Vector3(-1000, this.currentPosY, 0));
        points.push(new THREE.Vector3(1000, this.currentPosY, 0));

        this.guideLineGeometry.setFromPoints(points);
        this.guideLineGeometry.attributes.position.needsUpdate = true;
    }
    private itemTempPos: THREE.Vector3 = new THREE.Vector3();
    public HitTestItems(x: number, y: number) {
        const point = new THREE.Vector2(x, y);
        for (const item of this.items) {
            item.mesh.getWorldPosition(this.itemTempPos);
            if (item.isEnabled && item.status != MonsterStatus.HIT && item.colliderSize > point.distanceTo(new Vector2(this.itemTempPos.x, this.itemTempPos.y))) {
                item.SetStatus(MonsterStatus.HIT);
                return true;
            }
        }
        return false;
    }
    private addObject(idx: number, rowIdx: number) {
        if (idx >= 0) {
            //console.log("addObject:" + idx % this.data.length + ":" + rowIdx);
            for (let i = 0; i < this.data[idx % this.data.length].length; i++) {
                var dataInfoArr = this.data[idx % this.data.length][i].split(".");
                if (parseInt(dataInfoArr[0]) < 7) {
                    switch (parseInt(dataInfoArr[0]) as MonsterType) {
                        case MonsterType.COW:
                            const cow = new Cow();
                            cow.OnSound = this.OnSound;
                            cow.isDebug = this.isDebug;
                            cow.InitTexture(this.textureManager.GetMaterial(), 9, this.atlasIndexes[MonsterType.COW][parseInt(dataInfoArr[1])], 1.5);
                            cow.init(i - this.targetWidth * 0.5, rowIdx);
                            cow.SetDirection(Math.random() < 0.5 ? true : false);
                            this.add(cow);
                            this.monsters.push(cow);
                            break;
                        case MonsterType.CAT:
                            const cat = new Cat();
                            cat.OnSound = this.OnSound;

                            cat.isDebug = this.isDebug;
                            cat.InitTexture(this.textureManager.GetMaterial(), 9, this.atlasIndexes[MonsterType.CAT][parseInt(dataInfoArr[1])], 1.8);
                            cat.init(i - this.targetWidth * 0.5, rowIdx);
                            cat.SetDirection(Math.random() < 0.5 ? true : false);
                            cat.callBack = () => {
                                return this.blobCenter;
                            };
                            this.add(cat);
                            this.monsters.push(cat);
                            break;
                        case MonsterType.FROG:
                            const frog = new Frog();
                            frog.OnSound = this.OnSound;

                            frog.isDebug = this.isDebug;
                            frog.InitTexture(this.textureManager.GetMaterial(), 9, this.atlasIndexes[MonsterType.FROG][parseInt(dataInfoArr[1])], 2.2);
                            frog.SetDirection(Math.random() < 0.5 ? true : false);
                            frog.init(i - this.targetWidth * 0.5, rowIdx);
                            this.add(frog);
                            this.monsters.push(frog);
                            break;
                        case MonsterType.TREE:
                            const tree = new Tree();
                            tree.OnSound = this.OnSound;

                            tree.isDebug = this.isDebug;
                            tree.InitTexture(this.textureManagerTree.GetMaterial(), 5, this.atlasIndexes[MonsterType.TREE][parseInt(dataInfoArr[1])], 4);
                            tree.init(i - this.targetWidth * 0.5, rowIdx);
                            this.add(tree);
                            this.monsters.push(tree);
                            break;
                        case MonsterType.BIRD:
                            const bird = new Bird();
                            bird.OnSound = this.OnSound;
                            bird.isDebug = this.isDebug;
                            bird.InitTexture(this.textureManager.GetMaterial(), 9, this.atlasIndexes[MonsterType.BIRD][parseInt(dataInfoArr[1])], 2);
                            bird.SetDirection(Math.random() < 0.5 ? true : false);

                            let sx = -9;
                            let dx = 9;
                            if (i != 0) {
                                sx = 8;
                                dx = -9;
                            }
                            bird.init(sx, parseInt(dataInfoArr[2]), dx, parseInt(dataInfoArr[3]));
                            bird.SetRenderOrder(100);
                            this.add(bird);
                            this.monsters.push(bird);
                            break;
                        case MonsterType.HUMAN:
                            const human = new Human();
                            human.OnSound = this.OnSound;

                            human.InitTexture(this.textureManager.GetMaterial(), 9, this.atlasIndexes[MonsterType.HUMAN][parseInt(dataInfoArr[1])], 1.3);
                            human.init(i - this.targetWidth * 0.5, rowIdx);
                            human.SetDirection(Math.random() < 0.5 ? true : false);
                            if (!this.isDemo) {
                                human.OnBubbleShow = this.OnBubbleShow;
                            }
                            this.add(human);
                            this.monsters.push(human);
                            break;
                    }
                } else {
                    const item = new Item();
                    item.OnSound = this.OnSound;

                    item.InitTexture(this.textureManagerItem.GetMaterial(), 2, this.atlasIndexes[MonsterType.ITEM][parseInt(dataInfoArr[1])], 1.3);
                    item.init(parseInt(dataInfoArr[1]), parseInt(dataInfoArr[2]));
                    item.SetRenderOrder(9999);
                    //item.SetDirection(Math.random() < 0.5 ? true : false);
                    //item.OnBubbleShow = this.OnBubbleShow;
                    this.add(item);
                    this.items.push(item);
                }
            }
        }
    }
}